import { FC } from 'react';
import { Box, Flex, Spacer } from '@chakra-ui/react';
import { ListPageTitle } from 'components/atoms/ListPageTitle';
import { RegistrationButton } from 'components/atoms/RegistrationButton';

type Props = {
  handleClickRegistration: () => void;
};

export const ApiKeyTemplateHeaderView: FC<Props> = ({
  handleClickRegistration,
}) => (
  <Box m="40px 5px 0 5px">
    <Flex justifyContent="space-between" alignItems="center" h="40px">
      <ListPageTitle title="APIキーテンプレート一覧" />
      <Spacer />
      <RegistrationButton
        label="APIキーテンプレート新規作成"
        width="auto"
        onClick={handleClickRegistration}
      />
    </Flex>
  </Box>
);
